import { AppConstants } from '@shared/app-constants';
import { isDate, isNil, isString } from 'lodash';
import { DateTime } from 'luxon';

export const authTimeSpanInMs = AppConstants.TOKEN_VALIDITY_IN_MINUTES * 60 * 1000;

export const toUTCjsDate = (date: Date): Date => DateTime.fromJSDate(date).toUTC().toJSDate();

export const toUTCDateString = (date: Date): string => toUTCjsDate(date).toISOString();

// INFO: This should not set the time at midnight so it sets the date in wrong utc date - use Luxon library
export const toUTCDate = (date: Date): Date => {
  if (isNil(date)) {
    return null;
  }

  if (isString(date)) {
    date = new Date(date);
  }

  if (isDate(date)) {
    const utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

    return new Date(utcDate);
  }

  return null;
};

export const isLoginSessionExpired = (loginTimestamp: number) =>
  isNil(loginTimestamp) || loginSessionExpiryTimestamp(loginTimestamp) < Date.now();

export const loginSessionExpiryTimestamp = (loginTimestamp: number) => loginTimestamp + authTimeSpanInMs;

export const secondsToLoginSessionExpiry = (loginTimestamp: number) =>
  millisecondsToLoginSessionExpiry(loginTimestamp) / 1000;

export const millisecondsBeforeShowingLogoutCountdown = (loginTimestamp: number) => {
  const millisecondsBeforeExpiry = 30 * 60 * 1000;

  return millisecondsToLoginSessionExpiry(loginTimestamp) - millisecondsBeforeExpiry;
};

export const millisecondsToLoginSessionExpiry = (loginTimestamp: number) =>
  loginTimestamp + authTimeSpanInMs - Date.now();

export const getCountdownTime = (totalSeconds: number) => {
  const minRemaining = Math.floor(totalSeconds / 60);
  const secRemaining = Math.floor(totalSeconds - minRemaining * 60);
  const secRemainingWithTwoDigits = secRemaining < 10 ? `0${secRemaining}` : secRemaining;

  return `${minRemaining}:${secRemainingWithTwoDigits}`;
};
